import type { SignalFilters, Signal, IDraftSignal } from "../signal";

/**
 * Type guard to check if a signal is a draft signal
 *
 * @param signal - Signal to check
 * @returns True if signal is a draft with expiration
 *
 * @example
 * ```typescript
 * if (isDraftSignal(signal)) {
 *   const expires = signal.expiresAt;
 * }
 * ```
 */
function isDraftSignal<Filters extends SignalFilters = SignalFilters>(
    signal: Signal<Filters>,
): signal is IDraftSignal<Filters> {
    return signal.lifecycleStatus === "draft";
}

export default isDraftSignal;
